module.exports = __webpack_public_path__ + "img/red-trash.0127a591.svg";